import { useDepartmentStore, type CampaignData } from "@/features/department";
import { type DispatchContext, asRecord } from "./types";
import { appEvents } from "@/shared/lib/events";

/** Returns true if the tool was handled. */
export function dispatchGrowthTool(toolName: string, ctx: DispatchContext): boolean {
  const { payload } = ctx;
  const state = useDepartmentStore.getState();

  switch (toolName) {
    case "start_growth_research": {
      const rawInput =
        payload.growthInput && typeof payload.growthInput === "object"
          ? asRecord(payload.growthInput)
          : payload;
      const growthInput = {
        url: rawInput.url,
        businessName: rawInput.businessName,
        industry: rawInput.industry,
        valueProposition: rawInput.valueProposition,
        businessModel: rawInput.businessModel,
      };
      appEvents.publish({
        type: "agent-start-growth-research",
        growthInput: growthInput as unknown,
      });
      return true;
    }
    case "render_google_auth":
      state.updateCampaignData({ googleAuthStatus: "pending" } as Partial<CampaignData>);
      return true;
    case "propose_tracking_plan":
      state.updateCampaignData({ trackingEvents: payload.events } as Partial<CampaignData>);
      return true;
    case "provision_tracking":
      state.updateCampaignData({
        provisioningStatus: { gtm: "running", ga4: "running", linking: "running" },
      } as Partial<CampaignData>);
      return true;
    case "generate_campaign_assets":
      state.updateCampaignData({ growthCampaigns: payload.campaigns } as Partial<CampaignData>);
      return true;
    case "push_campaigns":
      state.updateCampaignData({ deploymentStatus: "pending" } as Partial<CampaignData>);
      return true;
    default:
      return false;
  }
}
